<template>
 <NavBarMore /> 
  <LoadStatus/>
  <!-- Body -->
  <div class="home">
      <!-- NavBar -->

    <Payment/>
    <Location/>
    <Transport/>
    <Living/>
    <Yamap/>
    <Cult/>
    <History/>
    <Contact/>
  </div>
  <Footer/>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import LoadStatus from '@/components/LoadSatus.vue'
import NavBarMore from '@/components/NavBarMore.vue'
import Payment from '@/components/PaymentBlock.vue'
import Location from '@/components/LocationBlock.vue'
import Transport from '@/components/TransportBlock.vue'
import Living from '@/components/LivingBlock.vue'
import History from '@/components/HistoryBlock.vue'
import Cult from '@/components/CultBlock.vue'
import Contact from '@/components/ContactBlock.vue'
import Yamap from '@/components/YaMap.vue'
import Footer from '@/components/FooterBlock.vue'
export default {
  name: 'MoreView',
  components: {
    //HelloWorld,
    NavBarMore,
    Payment,
    Location,
    Transport,
    Living,
    Yamap,
    Cult,
    History,
    Contact,
    Footer,
    LoadStatus
  }  
}



</script>
